import { type Particle, initRenderer } from "@infinitaslearning/app-player";

const ContentToHtml = initRenderer();

interface PlayerParticleHtmlProps {
  className?: string;
  particle: Particle;
}

/**
 *  This component can be used  to render a single Player particle with no specific theme. It can be
 * useful for rendering raw static text where Player logic is not needed.
 */
export const PlayerParticleHtml: React.FC<PlayerParticleHtmlProps> = ({ className, particle }) => (
  <ContentToHtml className={className} content={particle.portableTextContent} />
);
